<template>
  <section class="command-panel business-panel">
    <header><div><span v-if="eyebrow" class="business-eyebrow">{{ eyebrow }}</span><h2>{{ title }}</h2></div><slot name="action"><span class="business-caption">{{ caption }}</span></slot></header>
    <div class="business-panel-body"><slot /></div>
    <footer v-if="$slots.footer"><slot name="footer" /></footer>
  </section>
</template>
<script>
export default { props: { title: { type: String, required: true }, caption: { type: String, default: '' }, eyebrow: { type: String, default: '' } } }
</script>
